import React from "react";

class ResBotAspirante extends React.Component {
  constructor(props){
      super(props);
      this.state = {
        menuaspirante:{},
      };

      this.triggetNext = this.triggetNext.bind(this);
  }

  componentDidMount() {
    const { steps } = this.props;
    const { menuaspirante } = steps;
    let id = menuaspirante.value;
    let url ='http://127.0.0.1:8000/api/menu_aspirante/menu/'+id;
    fetch(url)
      .then(response => response.json())
      .then(data => {
        // Descomentar la siguiente línea para revisar la respuesta del API
        console.log(data);
        if(data.opcion === 'Departamento de Admisión'){
          this.triggetNext('consulta-correo');
        }else{
          this.triggetNext('fin-consulta');
        }
        //Actualiza el estado de la prop del componente respuesta con la respuesta del api 
        this.setState({ menuaspirante:data });
       
      })
      .catch(error => {
        // Aquí se maneja el error si es que falla la consulta al API
        this.setState({ menuaspirante:{'respuesta':'No se pudo establecer conexion con el servidor'} });
        //Imprime el error en consola en la siguiente linea 
        console.error(error);
      });
  }

    triggetNext(trigger) {
      this.setState({ trigger: true }, () => {
        this.props.triggerNextStep({trigger: trigger});
      });
    }

    render() {
      const { menuaspirante } = this.state;
      return (
        <div dangerouslySetInnerHTML={{__html: menuaspirante.respuesta}}></div>
      );
    }
  }
  
  export default ResBotAspirante;